window.locales = window.locales || {};window.locales.am = window.locales.am || {};window.locales.am.findCompanyStudentsBox = window.locales.am.findCompanyStudentsBox || {};window.locales.am.findCompanyStudentsBox = {...window.locales.am.findCompanyStudentsBox, ...{
    "heading": "{companyName} ተማሪዎችን ያግኙ",
    "content": "ለስራ ባልደረቦች እና ጓደኞች የተመራቂዎችን አውታረመረብ ያስሱ።",
    "button_view_students_and_alumni": "ተማሪዎችን እና የቀድሞ ተማሪዎችን ይመልከቱ"
}
};window.locales.ar = window.locales.ar || {};window.locales.ar.findCompanyStudentsBox = window.locales.ar.findCompanyStudentsBox || {};window.locales.ar.findCompanyStudentsBox = {...window.locales.ar.findCompanyStudentsBox, ...{
    "heading": "ابحث عن طلاب {companyName}",
    "content": "تصفح شبكة الخريجين للبحث عن الزملاء والأصدقاء.",
    "button_view_students_and_alumni": "عرض الطلاب والخريجين"
}
};window.locales.en = window.locales.en || {};window.locales.en.findCompanyStudentsBox = window.locales.en.findCompanyStudentsBox || {};window.locales.en.findCompanyStudentsBox = {...window.locales.en.findCompanyStudentsBox, ...{
    "heading": "Find {companyName} Students",
    "content": "Browse the alumni network for colleagues and friends.",
    "button_view_students_and_alumni": "View Students and Alumni"
}
};window.locales.es = window.locales.es || {};window.locales.es.findCompanyStudentsBox = window.locales.es.findCompanyStudentsBox || {};window.locales.es.findCompanyStudentsBox = {...window.locales.es.findCompanyStudentsBox, ...{
    "heading": "Encuentra estudiantes {companyName}",
    "content": "Explore la red de ex alumnos para encontrar colegas y amigos.",
    "button_view_students_and_alumni": "Ver estudiantes y exalumnos"
}
};window.locales.it = window.locales.it || {};window.locales.it.findCompanyStudentsBox = window.locales.it.findCompanyStudentsBox || {};window.locales.it.findCompanyStudentsBox = {...window.locales.it.findCompanyStudentsBox, ...{
    "heading": "Trova studenti {companyName}",
    "content": "Esplora la rete degli ex studenti per trovare colleghi e amici.",
    "button_view_students_and_alumni": "Visualizza studenti ed ex studenti"
}
};window.locales.zh = window.locales.zh || {};window.locales.zh.findCompanyStudentsBox = window.locales.zh.findCompanyStudentsBox || {};window.locales.zh.findCompanyStudentsBox = {...window.locales.zh.findCompanyStudentsBox, ...{
    "heading": "查找{companyName}学生",
    "content": "浏览校友网络以查找同事和朋友。",
    "button_view_students_and_alumni": "查看学生和校友"
}
};